import { refreshMunicipalPropertyManagement } from "@/domain/municipal-property/lib/refresh-municipal-property-management";
import { CreateMunicipalPropertyInput, CreateMunicipalPropertyMutation } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";

import { createMunicipalPropertyMutationDocument } from "./create-municipal-property-mutation.gql";
import { EVENT_MUNICIPAL_PROPERTY_CREATED, trackMunicipalPropertyEvent } from "./tracking";

export function useCreateMunicipalProperty({ refresh = true }: { refresh?: boolean } = {}): UseMutationResult<
  CreateMunicipalPropertyMutation["createMunicipalProperty"],
  Error,
  CreateMunicipalPropertyInput
> {
  const queryClient = useQueryClient();

  return useMutation({
    retry: false,
    mutationFn: async (input: CreateMunicipalPropertyInput) => {
      const client = createOperationClient("CreateMunicipalProperty");
      const response = await client.request(createMunicipalPropertyMutationDocument, { input });
      return response.createMunicipalProperty;
    },
    onSuccess: async (property, input) => {
      trackMunicipalPropertyEvent(EVENT_MUNICIPAL_PROPERTY_CREATED, {
        id: property.id,
        type: property.type,
        workspaceId: input.workspaceId,
      });
      if (!refresh) return;
      await refreshMunicipalPropertyManagement({
        queryClient,
        scope: {
          workspaceId: input.workspaceId,
          propertyIdList: [property.id],
        },
      }).catch(() => undefined);
    },
  });
}
